import { makeIcon } from "components/ui/Icon";

export const EmailIcon = makeIcon(
  <svg fill="none" viewBox="0 0 20 20">
    <path
      d="M3.33332 16.6667C2.87499 16.6667 2.48263 16.5035 2.15624 16.1771C1.82985 15.8507 1.66666 15.4584 1.66666 15V5.00004C1.66666 4.54171 1.82985 4.14935 2.15624 3.82296C2.48263 3.49657 2.87499 3.33337 3.33332 3.33337H16.6667C17.125 3.33337 17.5174 3.49657 17.8437 3.82296C18.1701 4.14935 18.3333 4.54171 18.3333 5.00004V15C18.3333 15.4584 18.1701 15.8507 17.8437 16.1771C17.5174 16.5035 17.125 16.6667 16.6667 16.6667H3.33332ZM9.99999 10.8334L3.33332 6.66671V15H16.6667V6.66671L9.99999 10.8334ZM9.99999 9.16671L16.6667 5.00004H3.33332L9.99999 9.16671ZM3.33332 6.66671V5.00004V15V6.66671Z"
      fill="currentColor"
    />
  </svg>,
);
